export default "\r\n<app-root></app-root>\r\n<site-footer></site-footer>"